export default {"src":"/_next/static/media/PurpleNextArrow.af0b72cb.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};